// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__vAxGX","show":"LoadingScreen_show__cXhxk","spinner":"LoadingScreen_spinner__KUrXN"};